import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';

@Component({
    selector: 'app-gate-keeper-control-widget',
    templateUrl: './gkc-widget.component.html',
    styleUrls: ['./gkc-widget.component.scss'],
    standalone: false
})
export class GateKeeperControlWidgetComponent extends AbstractWidgetComponent{

}
